import { alpha, Card, styled } from "@mui/material";
import { useContext } from "react";
import { useGetLinkDetailsRequest } from "src/services/link/queries/details";
import palette from "src/theme/palette";

import ErrorMessage from "../Common/ErrorMessage";
import InfoStepSkeleton from "../Common/InfoStep/components/InfoStepSkeleton";
import Powered from "../Common/InfoStep/components/Powered";
import ThemeContext from "../context";
import { useGetLinkEntities } from "../services/useGetLinkEntities";
import { useStartFlow } from "../services/useStartFlow";
import Context from "./context";
import useTransfersActionsStore from "./store";
import TransfersContent from "./TransfersContent";

const CustomCard = styled(Card)<{
	contentBackgroundColor?: string;
	type: string;
}>(({ contentBackgroundColor, type, theme }) => {
	const shadowColor = type === "dark" ? "#000000" : palette.light.grey[500];
	return {
		padding: "2rem",
		paddingBottom: "5rem",
		marginBottom: "5rem",
		width: "auto",
		backgroundColor: contentBackgroundColor,
		boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(shadowColor, 0.12)}`,
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			marginBottom: 0,
			minHeight: "96vh"
		}
	};
});

// ----------------------------------------------------------------------

export const TransfersCard = () => {
	const [state, actions] = useTransfersActionsStore();
	const { id, theme, themeType, isFrame, subproduct, product, ...other } = useContext(ThemeContext);

	const { isError } = useGetLinkEntities();

	const { isLoading } = useGetLinkDetailsRequest(id);

	useStartFlow({ subproduct });

	let content = <TransfersContent />;

	if (isError || other.state.isNotContracted) content = <ErrorMessage />;
	if (isLoading) content = <InfoStepSkeleton />;

	return (
		<CustomCard
			contentBackgroundColor={theme?.colors.contentBackground}
			type={themeType}
			sx={{ pb: !isFrame ? 9 : "2rem" }}
		>
			<Context.Provider value={{ state, actions }}>
				{content}
				{!isFrame && <Powered />}
			</Context.Provider>
		</CustomCard>
	);
};

export default TransfersCard;
